import React from 'react'
import "./Header.css"

function Header() {
    return (
        <div className="header">
            <h1>GradUI</h1>
        </div>
    )
}

export default Header
